import { useCallback } from 'react';
import { useHandleShowDialogs } from 'forms/hooks';
import { useDispatch } from 'react-redux';

import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';
import FileExport from '@gef-ui/material-icons/FileExport';

import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { ComponentLoader } from 'components/index';
import fetch from 'features/common/fetch';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { exportStatistics } from 'features/views/taskStatistics/actions';
import { TASK_STATISTICS_FORM_NAME } from 'features/views/taskStatistics/form';

export const Toolbar = () => {
	const dispatch = useDispatch();

	const subheaderTitle = useRenderSubheaderTitle({
		pageTitle: getLabelMessage('taskStatistics:header'),
		backButton: true,
	});

	const handleExport = useCallback(async () => {
		dispatch(exportStatistics());
	}, [dispatch]);

	const handleShowDialogsForExportSubmit = useHandleShowDialogs({
		page: TASK_STATISTICS_FORM_NAME,
		continueFn: handleExport,
	});

	const subheaderToolbar = (
		<ComponentLoader fetchStorePath={fetch.constants.urls.taskStatisticsExport} ignoreErrors>
			<SubmitButton
				size="small"
				variant="text"
				startIcon={<FileExport />}
				onClick={handleExport}
				onClickError={handleShowDialogsForExportSubmit}
				fullWidth
				text={getLabelMessage('common:export')}
			/>
		</ComponentLoader>
	);

	return <ToolbarTemplate leftSide={<Subheader title={subheaderTitle} />} rightSide={subheaderToolbar} />;
};

export default Toolbar;
